import api from "services/api"

/**
 * Fetch a paginated/filtered list of roles.
 *
 * @param {object} [filter={}]       - Filter criteria (e.g. { name, status }).
 * @param {object} [pagination={}]   - Pagination options (e.g. { page, limit }).
 * @returns {Promise<object>} API response payload.
 */
export const getRoles = async (filter = {}, pagination = {}) => {
  const response = await api.post("admin/roles/all", {
    ...filter,
    ...pagination,
  })
  return response.data
}

/**
 * Fetch the details of a single role.
 *
 * @param {string} roleId
 * @returns {Promise<object>}
 */
export const getRoleById = async roleId => {
  const response = await api.post("admin/roles/details", { id: roleId })
  return response.data
}

/**
 * Create a new role.
 *
 * @param {object} roleData - Role payload (name, permissions, …).
 * @returns {Promise<object>}
 */
export const createRole = async roleData => {
  const response = await api.post("admin/roles/add", roleData)
  return response.data
}

/**
 * Update an existing role.
 *
 * @param {string} roleId
 * @param {object} roleData - Fields to update.
 * @returns {Promise<object>}
 */
export const updateRole = async (roleId, roleData) => {
  const response = await api.put("admin/roles/details/update", {
    id: roleId,
    ...roleData,
  })
  return response.data
}

/**
 * Delete a role by ID.
 *
 * @param {string} roleId
 * @returns {Promise<object>}
 */
export const deleteRole = async roleId => {
  const response = await api.delete("admin/roles/delete", {
    data: { id: roleId },
  })
  return response.data
}
